<script>
import AdminPanel from '@components/admin-panel/admin-panel.vue';
import CircuitForm from '@components/forms/circuit-form.vue';
import EquipmentForm from '@components/forms/equipment-form.vue';
import ExerciseDetail from '@components/exercise/exercise-detail.vue';
import ExerciseStepForm from '@components/forms/exercise-step-form.vue';
import UseLargeScreen from '@components/use-large-screen.vue';
import ExerciseList from '@components/exercise/exercise-list.vue';
import Layout from '@layouts/main.vue';
import { adminPanelMixin } from '@mixins/admin-panel-mixin.js';
import { helperMixin } from '@mixins/helper-mixin';
import { cleverTapMixin } from '@mixins/cleverTap-mixin';
import { breakpointsMixin } from '@mixins/breakpoints-mixin.js';
import {
  adminPanelComputed,
  adminPanelMethods,
  authComputed,
  exerciseMethods,
} from '@state/helpers';

export default {
  page: {
    title: 'Exercise Detail',
    meta: [{ name: 'description', content: 'The Exercise Detail page.' }],
  },
  props: {
    exercise: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  components: {
    AdminPanel,
    CircuitForm,
    EquipmentForm,
    ExerciseDetail,
    ExerciseList,
    ExerciseStepForm,
    Layout,
    UseLargeScreen,
  },
  mixins: [adminPanelMixin, helperMixin, cleverTapMixin, breakpointsMixin],
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...adminPanelComputed,
    ...authComputed,
  },
  destroyed() {
    this.$_clearSelections();
  },
  methods: {
    ...adminPanelMethods,
    ...exerciseMethods,
    async showAdminPanel(component, data = null, size = '') {
      await this.setPanelContent(this.getPanelContent(component, data, size));
      this.setShowAdminPanel();
    },
    onSelectAltExercise(altExercise) {
      this.setSelectedAltExercise(altExercise);
      this.setHideAdminPanel();
    },
  },
};
</script>

<template>
  <UseLargeScreen v-if="isSmallScreenView" />
  <Layout v-else>
    <AdminPanel
      :title="panelContent ? panelContent.title : ''"
      :size="panelContent ? panelContent.size : ''"
    >
      <component
        v-if="panelContent"
        :is="panelContent.component"
        :content="panelContent"
        :showExerciseFilters="panelContent.showExerciseFilters"
        @select-exercise-item="onSelectAltExercise"
      />
    </AdminPanel>

    <div class="container-wrapper full dark" ref="contentWrapper">
      <ExerciseDetail :exercise="exercise" />
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
